import React from 'react'

const Fooddashbord = () => {
  return (
    <div>

    </div>
  )
}

export default Fooddashbord
